<template>
<button class="btn is-aitems-700" @click="$modal.show(modal)">
    <slot></slot>
</button>
</template>

<script>
    export default {
        props: ['modal']

    }
</script>